import EventEmitter from 'amkit3-modules/utils/stateful-events'
import ensureZepto from 'amkit3-modules/utils/ensure-zepto'
import UIEvent from 'amkit3-modules/v/ui/ui-event'
import DanmuEvent from 'amkit3-modules/v/danmu/danmu-event'
import { isFullscreen } from 'amkit3-modules/utils/fullscreen'
import HuyaUIEvent from './huya-ui-event'
import ContinuousBar from './continuous-bar'
import ControlBar from './control-bar'
import DanmuBar from './danmu-bar'
import Keyboard from './keyboard'
import EndedRecommend from './ended-recommend'
import Feedback from './feedback'
import themeFactory from './themes/factory'
import Drag from './Drag'
function isBrowserSupported(cb) {
  setTimeout(() => {
    if (typeof getComputedStyle !== 'function') {
      cb(new Error('no getComputedStyle'))
    } else {
      cb()
    }
  })
}

class HuyaUI extends EventEmitter {
  constructor(container, options, ready) {
    super()
    console.log('11112', $)
    ready = ready || function () {}

    isBrowserSupported(err => {
      if (err) {
        ready(err)
      } else {
        ensureZepto((_, $) => {
          this.init($, container, options, ready)
        })
      }
    })
  }
  init($, container, options, ready) {
    this.$ = $
    this.$container = this.$(container)
    if (!this.$container.length) {
      this.$container = this.$('body')
    }

    this.options = options

    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()
    this.config = themeFactory.getConfig()

    this.$container.append(
      themeFactory.getTemplate()({
        style: this.style,
      }),
    )
    if (this.options.no_danmu) {
      this.$container.find(this.selector.container).addClass(this.style.noDanmu)
    }
    this.$buffering = this.$container.find(this.selector.buffering)
    this.$error = this.$container.find(this.selector.error)
    this.$toggleIcon = this.$container.find(this.selector.toggle + ' ' + this.selector.icon)
    this.$toggle = this.$container.find(this.selector.toggle)
    this.volume = 1

    // CONTINUOUS BAR
    this.continuousBar = new ContinuousBar(this.$, this.$container, options)

    // CONTROL BAR
    this.controlBar = new ControlBar(this.$, this.$container, options)
    this.controlBar.on(
      UIEvent.TIME_CHANGE,
      this.statefulDelegate(() => {
        this.time = this.controlBar.getTime()
        this.emit(UIEvent.TIME_CHANGE)
      }),
    )
    this.controlBar.on(
      UIEvent.VOLUME_CHANGE,
      this.statefulDelegate(() => {
        this.volume = this.controlBar.getVolume()
        this.emit(UIEvent.VOLUME_CHANGE)
      }),
    )
    this.controlBar.on(
      UIEvent.PLAY_BUTTON_CLICK,
      this.statefulDelegate(() => {
        this.setPause()
        this.emit(UIEvent.PLAY_BUTTON_CLICK)
      }),
    )
    this.controlBar.on(
      UIEvent.PAUSE_BUTTON_CLICK,
      this.statefulDelegate(() => {
        this.setPlay()
        this.emit(UIEvent.PAUSE_BUTTON_CLICK)
      }),
    )
    this.controlBar.on(
      UIEvent.FULLSCREEN_BUTTON_CLICK,
      this.statefulDelegate(() => this.emit(UIEvent.FULLSCREEN_BUTTON_CLICK)),
    )
    this.controlBar.on(
      UIEvent.REPLAY_BUTTON_CLICK,
      this.statefulDelegate(() => {
        this.setPause()
        this.emit(UIEvent.REPLAY_BUTTON_CLICK)
        //this.endedRecommend&&this.endedRecommend.hide()
        // this.endedRecommend&&this.endedRecommend.emit(HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK)
        this.$toggleIcon.hide()
      }),
    )
    this.controlBar.on(
      HuyaUIEvent.DEFINITION_CHANGE,
      this.statefulDelegate(() => this.emit(HuyaUIEvent.DEFINITION_CHANGE)),
    )
    this.controlBar.on(
      HuyaUIEvent.PLAYBACK_RATE_CHANGE,
      this.statefulDelegate(() => this.emit(HuyaUIEvent.PLAYBACK_RATE_CHANGE)),
    )

    // ORIGIN EVENTS
    this.controlBar.on(UIEvent.PLAY_BUTTON_CLICK_O, () => {
      if (this.playButtonClickOTrigged) return
      this.playButtonClickOTrigged = true
      this.emit(UIEvent.PLAY_BUTTON_CLICK_O)
    })

    //去掉默认的contextmenu事件，否则会和右键事件同时出现。
    this.$container.on('contextmenu', e => {
      e.preventDefault()
    })
    this.$container.on('mousedown ', e => {
      if (e.button == 2) {
        const rightKeyPanel = this.$container.find(this.selector.rightKeyPanel)
        rightKeyPanel.show()
        rightKeyPanel.css({ left: e.pageX, top: e.pageY })
      } else {
        const rightKeyPanel = this.$container.find(this.selector.rightKeyPanel)
        setTimeout(() => {
          rightKeyPanel.hide()
        }, 200)
      }
    })
    console.log(
      'this.$container.find(this.selector.infoPanel)',
      this.$container.find(this.selector.infoPanel),
    )
    const drag = new Drag(this.$container.find(this.selector.infoPanel)[0], {
      limit: false,
      handle: this.$container.find(this.selector.infoTitle)[0],
      container: this.$container.find(this.selector.container)[0],
    })

    this.$container.find(this.selector.videoInfo).on('click', () => {
      const infoPanel = this.$container.find(this.selector.infoPanel)
      const rightKeyPanel = this.$container.find(this.selector.rightKeyPanel)
      this.setExtrData()
      setTimeout(() => {
        infoPanel.show()
        drag.toCenter()
        rightKeyPanel.hide()
        this.$container.find(this.selector.infoPanelClose).on('click', () => {
          infoPanel.hide()
        })
      }, 200)
    })
    // TOGGLE PANEL
    this.$container.on(
      'click',
      this.selector.toggle,
      this.statefulDelegate(evt => {
        // 如果点击的是icon元素或其子元素，则不处理
        if (this.$(evt.target).closest(this.selector.icon).length) return
        evt.stopPropagation()
        clearTimeout(this.tId)
        this.tId = setTimeout(() => this.toggle(), 200)
      }),
    )
    this.$container.on('click', this.selector.toggle + ' ' + this.selector.icon, evt => {
      evt.stopPropagation()
      this.toggle()
      this.emit(UIEvent.PLAY_BUTTON_CLICK_O)
    })
    this.$container.on(
      'dblclick',
      this.selector.toggle,
      this.statefulDelegate(() => {
        clearTimeout(this.tId)
        this.emit(UIEvent.FULLSCREEN_BUTTON_CLICK)
      }),
    )

    if (this.options.autoplay) {
      this.$toggleIcon.hide()
    }

    // DANMU BAR
    this.danmuBar = new DanmuBar(this.$, this.$container)
    this.danmuBar.on(
      DanmuEvent.ENABLE,
      this.statefulDelegate(() => this.emit(DanmuEvent.ENABLE)),
    )
    this.danmuBar.on(
      DanmuEvent.DISABLE,
      this.statefulDelegate(() => this.emit(DanmuEvent.DISABLE)),
    )
    this.danmuBar.on(DanmuEvent.SIGNIN, () => this.emit(DanmuEvent.SIGNIN))
    this.danmuBar.on(DanmuEvent.SIGNUP, () => this.emit(DanmuEvent.SIGNUP))
    this.danmuBar.on(
      DanmuEvent.SUBMIT,
      this.statefulDelegate(() => this.emit(DanmuEvent.SUBMIT)),
    )

    this.danmuBar.on(
      DanmuEvent.POSITION,
      this.statefulDelegate(position => this.emit(DanmuEvent.POSITION, position)),
    )
    this.danmuBar.on(
      DanmuEvent.SIZE,
      this.statefulDelegate(size => this.emit(DanmuEvent.SIZE, size)),
    )
    this.danmuBar.on(
      DanmuEvent.TYPE,
      this.statefulDelegate(type => this.emit(DanmuEvent.TYPE, type)),
    )
    this.danmuBar.on(
      DanmuEvent.TYPE_CHANGE,
      this.statefulDelegate(props => this.emit(DanmuEvent.TYPE_CHANGE, props)),
    )
    this.danmuBar.on(
      DanmuEvent.OPACITY,
      this.statefulDelegate(opacity => this.emit(DanmuEvent.OPACITY, opacity)),
    )
    this.danmuBar.on(
      DanmuEvent.OPACITY_END,
      this.statefulDelegate(opacity => this.emit(DanmuEvent.OPACITY_END, opacity)),
    )

    // controlbar active
    this.fullscreenUnactiveTId = 0
    this.fullscreenActive = evt => {
      clearTimeout(this.fullscreenUnactiveTId)
      this.$container.find(this.selector.container).addClass(this.style.active)

      if (this.$(evt.target).parents(this.selector.controlBar).length <= 0) {
        this.fullscreenUnactiveTId = setTimeout(() => {
          this.$container.find(this.selector.container).removeClass(this.style.active)
        }, 2000)
      }
    }

    this.isReady = true

    // keyboard
    this.keyboard = new Keyboard(this.$, this.$container)
    this.keyboard.on(
      UIEvent.KEYBOARD_TOGGLE,
      this.statefulDelegate(() => this.toggle()),
    )
    this.keyboard.on(
      UIEvent.KEYBOARD_TIME_STEP_BACKWARD,
      this.statefulDelegate(() => this.controlBar.timeStepBackward()),
    )
    this.keyboard.on(
      UIEvent.KEYBOARD_TIME_STEP_BACKWARD_DONE,
      this.statefulDelegate(() => this.controlBar.timeStepBackwardDone()),
    )
    this.keyboard.on(
      UIEvent.KEYBOARD_TIME_STEP_FORWARD,
      this.statefulDelegate(() => this.controlBar.timeStepForward()),
    )
    this.keyboard.on(
      UIEvent.KEYBOARD_TIME_STEP_FORWARD_DONE,
      this.statefulDelegate(() => this.controlBar.timeStepForwardDone()),
    )
    this.keyboard.on(
      UIEvent.KEYBOARD_VOLUME_UP,
      this.statefulDelegate(() => this.controlBar.volumeUp()),
    )
    this.keyboard.on(
      UIEvent.KEYBOARD_VOLUME_DOWN,
      this.statefulDelegate(() => this.controlBar.volumeDown()),
    )

    this.$container.on('mousemove', this.fullscreenActive)

    // ended recommend
    this.endedRecommend = new EndedRecommend(this.$, this.$container)
    this.endedRecommend.on(
      HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK,
      this.statefulDelegate(() => this.emit(HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK)),
    )
    this.endedRecommend.on(
      HuyaUIEvent.ENDED_RECOMMEND_COMMENT_BTN_CLICK,
      this.statefulDelegate(() => this.emit(HuyaUIEvent.ENDED_RECOMMEND_COMMENT_BTN_CLICK)),
    )
    this.endedRecommend.on(
      HuyaUIEvent.ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK,
      this.statefulDelegate(() => this.emit(HuyaUIEvent.ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK)),
    )

    this.feedback = new Feedback(this.$, this.$container)
    this.feedback.on(UIEvent.FEEDBACK_SUBMIT, data => this.emit(UIEvent.FEEDBACK_SUBMIT, data))

    ready()
  }
  setDuration(value) {
    this.statefulDelegate(value => {
      if (!this.isReady) return

      this.duration = value
      this.controlBar.setDuration(value)
    })(value)
  }
  // 设置extrData
  setExtrData() {
    setTimeout(() => {
      try {
        const extrData = window.huyaPlayer.player.core.playback.hyplayer.getVideoExtractData()
        const doms = this.$container.find(this.selector.videoData + ' em')
        this.$container.find(doms[0]).text(extrData?.codec)
        this.$container.find(doms[1]).text(extrData?.videoWidth + '/' + extrData?.videoHeight)
        this.$container.find(doms[2]).text(extrData?.frameRate || '-')
        this.$container.find(doms[3]).text(extrData?.bitrate)
      } catch (e) {}
    }, 200)
  }
  setTime(value) {
    this.statefulDelegate(value => {
      if (!this.isReady) return

      this.time = value
      this.controlBar.setTime(value)
    })(value)
  }
  getTime() {
    return this.time
  }
  setVolume(value) {
    this.volume = value
    this.controlBar.setVolume(value)
  }
  getVolume() {
    return this.volume
  }
  setError(_) {
    this.enable()
    this.setBuffering(false)
    this.disable()
    this.$error.css('visibility', 'visible')
  }
  removeError() {
    this.enable()
    this.$error.css('visibility', 'hidden')
  }
  setDefinition(definition) {
    this.statefulDelegate(definition => {
      this.controlBar.setDefinition(definition)
    })(definition)
  }
  setDefinitions(labels) {
    this.statefulDelegate(labels => {
      this.controlBar.setDefinitions(labels)
    })(labels)
  }
  getDefinition() {
    return this.controlBar.getDefinition()
  }
  getPlaybackRate() {
    return this.controlBar.getPlaybackRate()
  }
  setPlay() {
    this.setBuffering(false)
    this.statefulDelegate(() => {
      this.controlBar.setPlay()
      this.$toggleIcon.show()
    })()
  }
  setPause() {
    this.setBuffering(false)
    this.statefulDelegate(() => {
      this.controlBar.setPause()
      this.$toggleIcon.hide()
    })()
  }
  setReplay() {
    this.statefulDelegate(() => {
      this.controlBar.setReplay()
      this.$toggleIcon.show()
    })()
  }
  setBuffering(value) {
    this.statefulDelegate(() => {
      if (value) {
        this.$buffering.show()
      } else {
        this.$buffering.hide()
      }
    })()
  }
  containerChange() {
    this.controlBar.containerChange()
    if (isFullscreen()) {
      this.$container.find(this.selector.container).addClass(this.style.fullscreen)
    } else {
      this.$container.find(this.selector.container).removeClass(this.style.fullscreen)
    }
  }
  toggle() {
    if (this.controlBar.isPlay() || this.controlBar.isReplay()) {
      this.setPause()
      this.emit(UIEvent.PLAY_BUTTON_CLICK)
    } else {
      this.setPlay()
      this.emit(UIEvent.PAUSE_BUTTON_CLICK)
    }
  }
  enable() {
    super.enable()
    this.$container.find(this.selector.container).removeClass(this.style.disabled)
    this.controlBar.enable()
    this.danmuBar.enable()
    this.keyboard.enable()
  }

  disable() {
    super.disable()
    this.$container.find(this.selector.container).addClass(this.style.disabled)
    this.controlBar.disable()
    this.danmuBar.disable()
    this.keyboard.disable()
    // this.$toggleIcon.hide()
  }

  // danmu
  setDanmuValid(value) {
    this.danmuBar && this.danmuBar.setDanmuValid(value)
  }
  showDanmuType() {
    this.danmuBar && this.danmuBar.showDanmuType()
  }
  showLiveDanmuPop() {
    this.danmuBar && this.danmuBar.showLiveDanmuPop()
  }
  getDanmuContent() {
    if (this.danmuBar) return this.danmuBar.getDanmuContent()
    else return ''
  }
  danmuSubmitCountdown() {
    this.danmuBar && this.danmuBar.submitCountdown()
  }

  // continuous bar
  showContinuous(title, link) {
    this.continuousBar && this.continuousBar.show(title, link)
  }

  // ended recommend
  showEndedRecommend(data) {
    if (this.endedRecommend) {
      this.$container.find(this.selector.endedRecommend).show()
      this.endedRecommend.show(data)
    }
  }
  hideEndedRecommend() {
    this.$container.find(this.selector.endedRecommend).hide()
  }
  setEndedRecommendSubscribed() {
    this.endedRecommend && this.endedRecommend.setSubscribed()
  }
  setEndedRecommendUnsubscribe() {
    this.endedRecommend && this.endedRecommend.setUnsubscribe()
  }
}

export default HuyaUI
